import {
  PeriodicTasksQueryVariables,
  usePeriodicTasksLazyQuery,
} from "generated/graphql"
import { useEffect } from "react"

export const useAllPeriodicTasks = (
  variables: PeriodicTasksQueryVariables,
  skip?: boolean
) => {
  const variableString = JSON.stringify(variables)
  const [getDetails, response] = usePeriodicTasksLazyQuery()
  useEffect(() => {
    if (!skip) {
      getDetails({
        variables: {
          ...JSON.parse(variableString),
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variableString, skip])
  return response
}
